import {
    Connection,
    ConnectionLink,
    ConnectionLinkHubImport,
    ConnectionLinkImport,
    EntityWithStatus,
} from '../model/entities';
import providerAuthService from '../services/ProviderAuthService';
import adminApiAxios, { proxyApiAxios } from './CustomAxios';

class ConnectionLinkApi {
    list = async (connectionId: number): Promise<ConnectionLink[]> => {
        const response = await adminApiAxios.get<ConnectionLink[]>('/connection-links', {
            params: { connectionId },
        });

        return response.data;
    };

    get = async (id: number): Promise<ConnectionLink> => {
        const response = await adminApiAxios.get<ConnectionLink>(`/connection-links/${id}`);
        return response.data;
    };

    create = async (connectionLink: ConnectionLink, connection: Connection): Promise<ConnectionLink> => {
        const headers = await providerAuthService.getRequestHeader(connection.source?.provider!);
        const response = await adminApiAxios.post<ConnectionLink>('/connection-links', connectionLink, { headers });
        return response.data;
    };

    update = async (connectionLink: ConnectionLink, connection: Connection): Promise<ConnectionLink> => {
        const headers = await providerAuthService.getRequestHeader(connection.source?.provider!);
        const response = await adminApiAxios.put<ConnectionLink>(
            `/connection-links/${connectionLink.id}`,
            connectionLink,
            { headers },
        );
        return response.data;
    };

    delete = async (connectionLink: ConnectionLink, connection: Connection): Promise<void> => {
        const headers = await providerAuthService.getRequestHeader(connection.source?.provider!);
        await adminApiAxios.delete(`/connection-links/${connectionLink.id}`, { headers });
    };

    loadSpreadsheet = async (file: any, hubImport: ConnectionLinkHubImport): Promise<ConnectionLinkImport[]> => {
        const providerAccessTokens = await providerAuthService.getAccessTokens();
        hubImport.providerAccessTokens = providerAccessTokens;
        const formData = this.buildFormData(hubImport, file);
        const response = await proxyApiAxios.post<ConnectionLinkImport[]>('/connection-links/spreadsheets', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    };

    import = async (
        connectionLinks: ConnectionLink[],
        connection: Connection,
    ): Promise<EntityWithStatus<ConnectionLink>[]> => {
        const headers = await providerAuthService.getRequestHeader(connection.source?.provider!);
        const response = await adminApiAxios.post<EntityWithStatus<ConnectionLink>[]>(
            '/connection-links/bulk',
            connectionLinks,
            { headers },
        );
        return response.data;
    };

    /**
     * Builds a form data from a hub import object.
     * @param hubImport the hub import object
     * @param file the file
     * @returns the formdata
     */
    private buildFormData = (hubImport: ConnectionLinkHubImport, file: any) => {
        const formData: FormData = new FormData();
        const hubImportJson = JSON.stringify(hubImport);
        const hubImportBlob = new Blob([hubImportJson], { type: 'application/json' });
        formData.append('hubImport', hubImportBlob);
        formData.append('attachment', file);

        return formData;
    };
}

const connectionLinkApi: ConnectionLinkApi = new ConnectionLinkApi();
export default connectionLinkApi;
